import React from "react";
import PropTypes from "prop-types";
import "./sideMenuDAsettings.css";

const SideMenuDAsettings = ({ activeMenu, handleMenuItemClick, isVWDomainApprover }) => {
  return (
    <div className="side-menu-da-settings">
      <button
        className={`side-menu-item-da-settings ${activeMenu === "ECU Types" ? "active" : ""}`}
        onClick={() => handleMenuItemClick("ECU Types")}
      >
        ECU Types
      </button>
      <button
        className={`side-menu-item-da-settings ${activeMenu === "Make Model Year" ? "active" : ""}`}
        onClick={() => handleMenuItemClick("Make Model Year")}
      >
        Make Model Year
      </button>
      <button
        className={`side-menu-item-da-settings ${activeMenu === "Categories" ? "active" : ""}`}
        onClick={() => handleMenuItemClick("Categories")}
      >
        Categories
      </button>
      
      {isVWDomainApprover && (
        <button
          className={`side-menu-item-da-settings ${activeMenu === "Clusters" ? "active" : ""}`}
          onClick={() => handleMenuItemClick("Clusters")}
        >
          Clusters Management
        </button>
      )}
    </div>
  );
};

SideMenuDAsettings.propTypes = {
  activeMenu: PropTypes.string.isRequired,
  handleMenuItemClick: PropTypes.func.isRequired,
  isVWDomainApprover: PropTypes.bool,
};

export default SideMenuDAsettings;
